import { render, staticRenderFns } from "./TopApps.vue?vue&type=template&id=568e16e2&"
import script from "./TopApps.vue?vue&type=script&lang=js&"
export * from "./TopApps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports